__turbopack_context__.v({
  "wrapper": "sidebar-layout-provider-module-scss-module__PAsP2G__wrapper",
});
